"use strict";
'use es6';

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));

var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));

var _react = _interopRequireDefault(require("react"));

var _reactRedux = require("react-redux");

var _ConfigurationPropertyOptionsTable = _interopRequireDefault(require("FormsCommonComponents/editor/configuration/ConfigurationPropertyOptionsTable"));

var _DragDropContext = _interopRequireDefault(require("lead-flows-ui/utils/DragDropContext"));

var _RouteGenerators = require("lead-flows-ui/lib/RouteGenerators");

var _ContactProperties = require("lead-flows-ui/selectors/ContactProperties");

var ConfigurationPropertyOptionsTableWrapper =
/*#__PURE__*/
function (_React$PureComponent) {
  (0, _inherits2.default)(ConfigurationPropertyOptionsTableWrapper, _React$PureComponent);

  function ConfigurationPropertyOptionsTableWrapper() {
    (0, _classCallCheck2.default)(this, ConfigurationPropertyOptionsTableWrapper);
    return (0, _possibleConstructorReturn2.default)(this, (0, _getPrototypeOf2.default)(ConfigurationPropertyOptionsTableWrapper).apply(this, arguments));
  }

  (0, _createClass2.default)(ConfigurationPropertyOptionsTableWrapper, [{
    key: "render",
    value: function render() {
      var _this$props = this.props,
          formField = _this$props.formField,
          handleChange = _this$props.handleChange,
          contactProperties = _this$props.contactProperties;
      return _react.default.createElement(_ConfigurationPropertyOptionsTable.default, {
        formField: (0, _extends2.default)({}, formField, {
          propertyObjectType: 'CONTACT',
          selectedOptions: formField.selectedOptions || []
        }),
        handleChange: handleChange,
        properties: contactProperties,
        getPropertyEditorRoute: _RouteGenerators.getPropertyEditorRoute,
        getPersonaEditorRoute: _RouteGenerators.getPersonaEditorRoute,
        allowPropertyEdits: true
      });
    }
  }], [{
    key: "propTypes",
    get: function get() {
      return {
        formField: _react.default.PropTypes.object.isRequired,
        handleChange: _react.default.PropTypes.func.isRequired,
        contactProperties: _react.default.PropTypes.array.isRequired
      };
    }
  }]);
  return ConfigurationPropertyOptionsTableWrapper;
}(_react.default.PureComponent);

var mapStateToProps = function mapStateToProps(state) {
  return {
    contactProperties: (0, _ContactProperties.getProperties)(state)
  };
};

var actionsToBind = {};

var _default = (0, _DragDropContext.default)()((0, _reactRedux.connect)(mapStateToProps, actionsToBind)(ConfigurationPropertyOptionsTableWrapper));

exports.default = _default;
module.exports = exports.default;